<template>
  <ContactSection
    :title="sectionData.name || ''"
    :description="sectionData.description || ''"
    :button-name="sectionData.link?.name || ''"
    :button-url="sectionData.link?.url"
    :button-id="isCN ? 'tracking_contactUs' : undefined"
  />
</template>

<script setup lang="ts">
  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });

  const { isCN } = useLanguage();
</script>
